import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClasses } from "../../redux/services/classesSlice";
import Table from "../../common/Table";

const Classes = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const getClassesData = useSelector((state) => state?.classes?.classesData);
  const getAllClasses = useCallback(async () => {
    try {
      await dispatch(
        getClasses({ page: page + 1, limit: pageLimit, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllClasses();
  }, [getAllClasses]);
  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { header: "Owner Name", key: "ownerName" },
    { header: "Class Name", key: "name" },
    { header: "Email", key: "email" },
    {
      header: "Contact",
      key: "contact",
      render: (value) => value?.countryCode + " " + value?.mobile,
    },
    { header: "Referral Code", key: "referralCode" },
    {
      header: "Image",
      key: "image",
      render: (value) =>
        value ? (
          <button className="max-w-16 max-h-16 rounded-lg">
            <img src={value} alt="" className="w-full h-full" />
          </button>
        ) : (
          "—"
        ),
    },
  ];

  return (
    <>
      <Table
        title="Classes"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        columns={columns}
        data={getClassesData?.classes_data}
        pageCount={getClassesData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
    </>
  );
};

export default Classes;
